import { Action } from 'redux';
import analytics from '../../analytics';

export const initialState = {};

export interface RequestAction extends Action {
  payload: {
    error?: boolean;
    message?: string;
    validating?: boolean;
    submitting?: boolean;
  };
}

const request = (state = initialState, action: RequestAction) => {
  switch (action.type) {
    case 'REQUEST_ERROR':
      const message = action.payload.message
        ? action.payload.message
        : 'Sorry, something went wrong. Please try again.';

      if (action.payload.error) {
        window.scrollTo(0, 0);
        analytics.error(message);
      }

      return { ...action.payload, message: message, submitting: false, validating: false };

    case 'REQUEST_STATE':
      return { ...state, ...action.payload };

    case 'SET_RECOMMENDATION':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default request;
